import React from "react";
import logoBlack from "components/svg/logo-black.svg";
import logoWhite from "components/svg/logo-white.svg";


export default function Logo({color = "white", ...props}) {
  
  return (
    <img alt="" src={color === "white" ? logoWhite : logoBlack} {...props} />
  );

}
